export function docus_checklist_eval(id, val) {
    if (val=='' || val==undefined) {
        $('#'+id+'_caption').parent().parent().addClass('checklist_warning');
        $('#'+id+'_caption').parent().parent().removeClass('checklist_ok');
        $('#'+id+'_caption').addClass('checklist_warning');
        $('#'+id+'_caption').removeClass('checklist_ok');
    } else {
        $('#'+id+'_caption').parent().parent().addClass('checklist_ok');
        $('#'+id+'_caption').parent().parent().removeClass('checklist_warning');
        $('#'+id+'_caption').addClass('checklist_ok');
        $('#'+id+'_caption').removeClass('checklist_warning');
    }
}


export function count_docu_checkboxes_checked(docus_class) {
    // returns count of checked checkboxes of class 'docu_class'
    //
    var max_checked=0;
    $("."+docus_class).each(function() {
        if ($(this).is(":checked")) { max_checked+=1;}
    });
    return max_checked;
}

export function count_docu_checkboxes_checked_except_none(docus_class, id_none) {
    // returns count of checked checkboxes of class 'docu_class' except the one with id of 'none' option
    var max_checked=0;
    $("."+docus_class).not('#'+id_none).each(function() {
        if ($(this).is(":checked")) { max_checked+=1;}
    });
    return max_checked;
}



export function get_checkboxes_results(id_base, field_prefix) {
    // get_checkboxes_results('docus_bam', 'fs');
    // DEBUG_OK 220110
    var checkboxes_class = id_base + '_' + field_prefix + '_option';
    var result_field = id_base + '_' + field_prefix + '_result';
    var count_checked = count_docu_checkboxes_checked(checkboxes_class);
    if (count_checked===0) {
        $('#'+result_field).val('');
    } else {
        $('#'+result_field).val(count_checked);
    }
    evaluate_mandatory_fields(id_base);
}



export function cancel_all_docus_options_for_none(id_none, id_prefix, docus_class) {
    // called by event handler for option 'none' (keine, keiner) from a list of checkboxes
    // if id_none ist set, all other options from class 'docus_class' will bei disabled
    // includes updating css of the corresponding label
    if ($('#'+id_none).is(":checked")) {
        $('.'+docus_class).not('#'+id_none).prop('checked', false);
        $("span[id^='"+id_prefix+"']").not('#'+id_none+'_label').removeClass('checked');
    }
}

export function cancel_docus_none_option(id_none) {
    $('#'+id_none).prop('checked', false);
    $('#'+id_none+'_label').removeClass('checked');
}



export function evaluate_mandatory_fields(id_prefix) {
    // id_prefix: e.g. 'docus_bam'
    // check all VISIBLE input elements starting with 'id_prefix' for 'data-mandatory' attribute beeing 'true'
    // evaluate their value
    // if empty, set corresponding '_label' element class to 'warning'
    // called by item_trigger_functions.js/item_mandatory_handler AND check_for_mandatory_docus_field,

    // DEBUG INFO:  [data-mandatory='true']:visible  ignores hidden input fields - as used fro checkbox-array result-field
    var missing_labels = '';
    $("[id^='"+id_prefix+"_phase']:visible [data-mandatory='true'], [id^='"+id_prefix+"_section']:visible [data-mandatory='true']").each(function() {
        //console.log($(this).attr('id')+',  field_val: '+window[$(this).attr('id')+'_get_field_val']());

        var field_val = window[$(this).attr('id') + '_get_field_val']();
        var label_of_missing_field = $('#' + $(this).attr('id') + '_label');

        if (field_val=='' || field_val==false) {
            label_of_missing_field.addClass('warning');
            if (missing_labels != '') missing_labels += ', '
            missing_labels += label_of_missing_field.html().replace('*', '').trim();
        } else {
            label_of_missing_field.removeClass('warning');
        }
    });

    if ($('#'+id_prefix+'_mandatory_missings')) {
        $('#'+id_prefix+'_mandatory_missings').val(missing_labels);
        $('#'+id_prefix+'_mandatory_missings_text').text(missing_labels);
        $('#'+id_prefix+'_mandatory_missings').trigger('change');
    }

}


export function findDuplicateIds(showDetails = true) {
    const ids = {};
    const duplicates = [];

    $('[id]').each(function () {
        const id = this.id;
        if (ids[id]) {
            ids[id].push(this);
        } else {
            ids[id] = [this];
        }
    });

    Object.keys(ids).forEach(id => {
        if (ids[id].length > 1) {
            duplicates.push({ id: id, elements: ids[id] });
        }
    });

    if (showDetails && duplicates.length > 0) {
        console.group('⚠️ Duplicate IDs found:');
        duplicates.forEach(dup => {
            console.group(`ID: #${dup.id} — ${dup.elements.length} duplicates`);
            dup.elements.forEach((el, idx) => {
                console.log(
                    `#${idx + 1}: <${el.tagName.toLowerCase()} type="${$(el).attr('type') || ''}" name="${$(el).attr('name') || ''}" value="${$(el).val ? $(el).val() : el.textContent.trim()}" />`,
                    el
                );
            });
            console.groupEnd();
        });
        console.groupEnd();
    } else if (duplicates.length === 0) {
        console.log('✅ No duplicate IDs found.');
    }

    return duplicates;
}

// GLOBAL VALIDATION BASE (shared across all docus_xyz forms)

export async function global_docus_check_datetime_fields(config) {
    console.log("🔧 global_docus_check_datetime_fields (async + success keys)", config.form_prefix);

    const {
        aggregated_mode = false,
        aggregated_error_div = ['#mandatory_missings_section'],
        buttons = [],
        validations = [],
        asyncValidations = null, // optional async validation config
    } = config;

    const errorDivs = Array.isArray(aggregated_error_div)
        ? aggregated_error_div
        : [aggregated_error_div];

    const results = [];
    let all_success = true;

    // --- 1️⃣ Run synchronous moment-based validations ------------------------
    for (const v of validations) {
        const fn = v.fn;
        const args = v.args;

        const res = fn.apply(null, args.concat([aggregated_mode]));

        // Normalize result shape
        const resultObj = (aggregated_mode && res && typeof res === 'object')
            ? { success: !!res.success || !!res.ok, message: res.message }
            : { success: res !== false, message: '' };

        if (!resultObj.success) results.push(resultObj);
        if (!resultObj.success) all_success = false;
    }

    // --- 2️⃣ Run optional async validation ----------------------------------
    for (const asyncValidation of asyncValidations) {
        if (typeof asyncValidation.fn !== 'function') continue;

        try {
            const asyncRes = await asyncValidation.fn.apply(null, asyncValidation.args);
            if (asyncRes && asyncRes.success === false) {
                results.push(asyncRes);
                all_success = false;
            }
        } catch (err) {
            console.error("❌ Async validation failed:", err);
            results.push({ success: false, message: "Interner Validierungsfehler (async)." });
            all_success = false;
        }
    }

    // --- 3️⃣ Aggregated error display --------------------------------------
    if (aggregated_mode) {
        errorDivs.forEach(divSelector => {
            const $div = $(divSelector);
            if ($div.length === 0) {
                console.warn(`⚠️ Aggregated error div not found: ${divSelector}`);
                return;
            }

            $div.find('.warning').remove();
            results.forEach(r => {
                if (!r.success) $('<div>')
                    .addClass('warning')
                    .text(r.message)
                    .appendTo($div);
            });

            if (results.some(r => !r.success)) {
                $div.show();
            } else {
                $div.hide();
            }
        });

        if (results.some(r => !r.success)) disableUiButtons(buttons);
        else enableUiButtons(buttons);
    }

    console.log(`✅ ${config.form_prefix} validation complete → all_success:`, all_success);
    return { success: all_success, results: results };
}


export async function runAsyncDocuModelDateValidations____UNUSED_BY_NOW_____(scope, dm_von, dm_bis, sequence_id) {
    console.log("🕒 runAsyncDocuModelDateValidations...");
    try {
        const asyncRes = await check_docu_model_date(scope, dm_von, dm_bis, sequence_id);
        // Ensure correct format
        if (asyncRes && typeof asyncRes.success === 'boolean') {
            return asyncRes;
        } else {
            return { success: false, message: "Ungültige Server-Antwort (async)." };
        }
    } catch (err) {
        console.error("check_docu_model_date() error:", err);
        return { success: false, message: "Async Datumsprüfung fehlgeschlagen." };
    }
}


export async function check_docu_model_date(scope, mode, docu_model, dm_von_id, dm_bis_id, sequence_id) {
    try {
        const dm_von = moment($(dm_von_id).val(), 'DD.MM.YYYY');
        const dm_bis = moment($(dm_bis_id).val(), 'DD.MM.YYYY');
        const response = await $.ajax({
            url: '/time_records/ajax_check_docu_date',
            type: 'POST',
            data: { scope: scope,
                mode: mode,
                docu_model: docu_model,
                dm_von:         dm_von.isValid() ? dm_von.format('YYYY-MM-DD HH:mm') : null,
                dm_bis:         dm_bis.isValid() ? dm_bis.format('YYYY-MM-DD HH:mm') : null,
                sequence_id:    $(sequence_id).val()
            },
        });

        // Interpret the structured result
        if (response && response.success) {
            //$('#form_eval_error_for_docu_date').val(false);
            return { success: true, message: '' };
        } else {
            //$('#form_eval_error_for_docu_date').val(true);
            return {
                success: false,
                message: (response && response.message)
                    ? response.message
                    : 'Fehler aber keine Beschreibung für ' + scope
            };
        }

    } catch (e) {
        //console.error('check_docu_date_tr ist leider fehlgeschlagen', e);
        return {
            success: false,
            message: ('Fehler beim Prüfen des Journal-Datums für ' + scope)
        }
    }
}